import config from '../configuration/config';
import { type Unsubscribe } from '../types/store';

function subscribeOnChange(callback: () => void): Unsubscribe {
  const store = config.getStore();

  return store.subscribe(callback);
}

export default subscribeOnChange;
